import { clsx } from "clsx"

export function cn(...inputs: any[]) {
  return clsx(inputs)
}

export function getCsrfToken(): string {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || ""
}

export function copyToClipboard(text: string) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        App.displayFlash("success", i18n.t("js.copied"))
      })
      .catch(() => {
        // Fallback to App.executeCopy
        ;(window as any).App.executeCopy(text)
        App.displayFlash("success", i18n.t("js.copied"))
      })
  } else {
    // Fallback to App.executeCopy
    ;(window as any).App.executeCopy(text)
    App.displayFlash("success", i18n.t("js.copied"))
  }
}

export function formatDate(isoDate: string | null | undefined): string {
  if (!isoDate) return ""
  try {
    return new Date(isoDate).toLocaleDateString(undefined, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
  } catch {
    return ""
  }
}
